@if (carregando()) {
  <section class="dz-card estado">
    <app-cog-loading-spinner [size]="72" />
    <span>Consultando a Receita Federal…</span>
  </section>
} @else if (erro(); as e) {
  <section class="dz-card dz-card__body">
    <p class="dz-note" [class.dz-note--alert]="e.tipo === 'indisponivel'">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>{{ textoDoErro(e) }}</span>
    </p>
    @if (e.tipo === 'indisponivel') {
      <div class="retry">
        <app-button
          [label]="'Tentar de novo'"
          [icon]="'refresh'"
          [theme]="'outline-grey'"
          [type]="'button'"
          (sendButtonClick)="tentarDeNovo()"></app-button>
      </div>
    }
  </section>
} @else if (empresa(); as emp) {
  <div class="painel">
    <app-registry-company-card [empresa]="emp" />
    <app-registry-partners-card [socios]="emp.socios ?? []" />
    @if (showNetwork()) {
      <app-registry-network-card [cnpj]="cnpj()" />
    }
  </div>
}
